var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.8486 7.95148C19.3173 8.42011 19.3173 9.17991 18.8486 9.64853L12.4972 16L18.8486 22.3515C19.3173 22.8201 19.3173 23.5799 18.8486 24.0485C18.38 24.5172 17.6202 24.5172 17.1516 24.0485L9.95157 16.8485C9.48294 16.3799 9.48294 15.6201 9.95157 15.1515L17.1516 7.95148C17.6202 7.48285 18.38 7.48285 18.8486 7.95148Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
